<template>
  <div class="card">
    <div class="inner-card">
      <asset-v3
        class="inner-card--icon"
        dir="icons"
        name="check-circle-success.svg"
      />
      Sua parcela foi paga
    </div>
    <div class="card-body">
      <div class="card-body--header">
        <h1 class="header_title">Pedido {{ orderId }}</h1>
        <p class="header_subtitle">Realizado em {{ purchasedDate | dateFilter }}</p>
      </div>
      <div class="card-body--content">
        <div class="content_section border-bottom">
          <h2 class="section_name">Parcela</h2>
          <p class="section_value">{{ installmentNumber }}/{{ installmentNumbers }}</p>
        </div>
        <div class="content_section border-bottom">
          <h2 class="section_name">Valor</h2>
          <p class="section_value">{{ installmentValue | moneyFilter }}</p>
        </div>
        <div class="content_section border-bottom">
          <h2 class="section_name">Vencimento</h2>
          <p class="section_value">{{ installmentDueDate | dateFilter }}</p>
        </div>
        <div class="content_section">
          <h2 class="section_name">Pagamento confirmado em</h2>
          <p class="section_value">{{ installmentPayDay | dateFilter }}</p>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <AnchorButton
        class="footer_button"
        :href="'http://app.parcelex.com.br/login'"
        :target="'_blank'"
        content="Ver no Parcelex"
      />
    </div>
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import AssetV3 from '@/components/common/AssetV3.vue';
import AnchorButton from './AnchorButton.vue';

export default {
  name: 'DesktopContainer',
  components: {
    AssetV3,
    AnchorButton,
  },
  props: {
    orderId: {
      type: String,
    },
    purchasedDate: {
      type: String,
    },
    installmentNumber: {
      type: Number,
    },
    installmentNumbers: {
      type: Number,
    },
    installmentValue: {
      type: Number,
    },
    installmentDueDate: {
      type: String,
    },
    installmentPayDay: {
      type: String,
    },
  },
  mixins: [StringMixin],
};
</script>

<style lang="scss" scoped>
  .card {
    border: none !important;
    border-radius: 0 !important;

    background-color: var(--white);
    font-family: var(--font-family);

    width: 100%;
    padding: 24px;

    @media (min-width: $lg) {
      border-radius: 8px !important;
      width: 486px;

      border-radius: 8px;
      border: 1px solid var(--gray-200) !important;
      height: fit-content;
      padding: 20px;

      margin-top: 36px;
    }
  }

  .inner-card {
    @extend .body-bold;
    display: flex;
    align-items: center;
    color: var(--green-700);

    padding: 16px 22px;
    background-color: var(--green-100);
    border-radius: 8px;
  }
  .inner-card--icon {
    padding-right: 12px;
  }
  .card-body--header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    padding-top: 24px;

    .header_title {
      @extend .body-bold;
      font-family: var(--font-family);
    }
    .header_subtitle {
      @extend .x-small-regular;
      font-family: var(--font-family);
      color: var(--gray-500);
    }

  }
  .card-body--content {
    margin-top: 8px;
    display: flex;
    flex-direction: column;

    .border-bottom {
      border-bottom: 1px solid var(--gray-200);
    }
    .content_section {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      padding: 12px 0;

      .section_name {
        @extend .small-regular;
        font-family: var(--font-family);
        font-weight: 400;
      }
      .section_value {
        @extend .small-semibold;
        font-family: var(--font-family);
      }
    }
  }
  .card-footer {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 24px;

    .footer_button {
      width: 100%;
      padding: 7px 14px;

      @media (min-width: $lg) {
        width: fit-content;
      }
    }
  }
</style>
